export default __webpack_public_path__ + "static/media/twitter.fd7692b7.svg";